import { render, staticRenderFns } from "./CourseModules.vue?vue&type=template&id=750a3253&scoped=true&"
import script from "./CourseModules.vue?vue&type=script&lang=js&"
export * from "./CourseModules.vue?vue&type=script&lang=js&"
import style0 from "./CourseModules.vue?vue&type=style&index=0&id=750a3253&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a3253",
  null
  
)

export default component.exports